<script setup lang="ts">
type Props = {
  bgColor?: string
  textColor?: string
  text: string
}

const props = withDefaults(defineProps<Props>(), {
  bgColor: '',
  textColor: '',
})

const style = computed(() => {
  const styles: Partial<Record<string, string>> = {}

  if (props.bgColor) styles['--backgroundColor'] = props.bgColor
  if (props.textColor) styles['--textColor'] = props.textColor

  return styles
})
</script>

<template>
  <span class="app-status" :style="style">
    {{ text }}
  </span>
</template>

<style lang="scss" scoped>
.app-status {
  display: inline-block;
  max-width: 155px;
  height: 24px;
  padding: 4px 8px;
  overflow: hidden;
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;
  color: var(--textColor, #ffffff);
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
  background-color: var(--backgroundColor, #423d7e);
  border-radius: 100px;
}
</style>
